import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, Shield, BookOpen, ShoppingBag, AlertCircle } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <Section background="cream" className="pb-24" id="oferta" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-100" data-id="element-116">
          <div className="bg-stone-900 p-6 text-center" data-id="element-117">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-118">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="text-amber-400 mt-2 font-medium" data-id="element-119">
              Domina la técnica hoy mismo
            </p>
          </div>

          <div className="p-8 md:p-12 grid md:grid-cols-2 gap-12 items-center" data-id="element-120">
            <div data-id="element-121">
              <div className="mb-8" data-id="element-122">
                <span className="text-stone-500 text-lg line-through decoration-red-500 decoration-2" data-id="element-123">
                  $97 USD
                </span>
                <div className="flex items-baseline gap-2" data-id="element-124">
                  <span className="text-5xl font-bold text-stone-900" data-id="element-125">
                    $6.39
                  </span>
                  <span className="text-xl text-stone-600 font-medium" data-id="element-126">
                    USD
                  </span>
                </div>
                <div className="mt-2 inline-flex items-center gap-1 text-green-600 bg-green-50 px-2 py-1 rounded text-sm font-bold" data-id="element-127">
                  Ahorras 90% hoy
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-128">
                <li className="flex items-start gap-3" data-id="element-129">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-130" />
                  <span className="text-stone-700" data-id="element-131">
                    <strong data-id="element-132">Guía Maestra Mil Hojas Pro</strong> (PDF Digital)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-133">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-134" />
                  <span className="text-stone-700" data-id="element-135">
                    <strong data-id="element-136">Lista de Marcas en EE.UU.</strong> (Walmart, Target,
                    etc)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-137">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-138" />
                  <span className="text-stone-700" data-id="element-139">
                    <strong data-id="element-140">Checklist de Emergencia</strong> para Humedad Alta
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-141">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-142" />
                  <span className="text-stone-700" data-id="element-143">
                    Acceso Inmediato y de por vida
                  </span>
                </li>
              </ul>

              <Button size="lg" fullWidth className="text-lg mb-4" onClick={() => {
              trackAddToCart();
              window.open('https://novadigitalventures.com/cart/42538050125895:1', '_blank');
            }} data-id="element-144">
                Obtener la Guía Maestra - $6.39
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-stone-500" data-id="element-145">
                <Shield className="w-3 h-3" data-id="element-146" />
                Pago 100% Seguro y Encriptado
              </div>
            </div>

            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100" data-id="element-147">
              <h3 className="font-bold text-stone-900 mb-4 flex items-center gap-2" data-id="element-148">
                <BookOpen className="w-5 h-5 text-amber-600" data-id="element-149" />
                ¿Qué recibirás?
              </h3>
              <div className="space-y-4 text-sm text-stone-600" data-id="element-150">
                <p data-id="element-151">
                  Este no es un libro de cocina tradicional. Es un manual
                  técnico simplificado que te enseña el <strong data-id="element-152">POR QUÉ</strong>{' '}
                  y el <strong data-id="element-153">CÓMO</strong>.
                </p>
                <p data-id="element-154">
                  Olvídate de ingredientes extraños. Te enseñaré a usar lo que
                  ya encuentras en tu supermercado local para lograr resultados
                  de alta pastelería.
                </p>
                <div className="pt-4 border-t border-stone-200" data-id="element-155">
                  <div className="flex items-center gap-3" data-id="element-156">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-157">
                      <Shield className="w-6 h-6 text-amber-600" data-id="element-158" />
                    </div>
                    <div data-id="element-159">
                      <p className="font-bold text-stone-900 text-sm" data-id="element-160">
                        Garantía de Hierro
                      </p>
                      <p className="text-xs text-stone-500" data-id="element-161">
                        Si tu Mil Hojas no cruje, te devuelvo tu dinero. Sin
                        preguntas.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}